/* Reveal on scroll.

   Adds .is-visible to anything marked [data-reveal] inside this element.

   mode="each"  — every item reveals as it reaches the viewport (default)
   mode="group" — the whole set reveals together, staggered, once the element
                  is reached

   The hidden state lives behind reveal-group:defined in CSS, so if this script
   never loads nothing is ever invisible. */

class RevealGroup extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-reveal]'));
    if (!this.items.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      this.showAll(0);
      return;
    }

    this.stagger = Number(this.dataset.stagger) || 110;
    this.mode = this.dataset.mode === 'group' ? 'group' : 'each';

    if (this.mode === 'group') {
      this.watchGroup();
    } else {
      this.watchEach();
    }
  }

  showAll(step) {
    this.items.forEach(function (item, i) {
      if (!step) {
        item.classList.add('is-visible');
        return;
      }
      setTimeout(function () {
        item.classList.add('is-visible');
      }, i * step);
    });
  }

  watchGroup() {
    var self = this;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        self.showAll(self.stagger);
        observer.disconnect();
      });
    }, { threshold: 0.15 });

    observer.observe(this);
  }

  watchEach() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    this.items.forEach(function (item) {
      observer.observe(item);
    });
  }
}

if (!customElements.get('reveal-group')) {
  customElements.define('reveal-group', RevealGroup);
}
